import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

class AddButton extends Component {
  onAddPart() {
    return () => {
      const {
        filters,
        addConfig,
        onTogglePopup,
        onUpdateCurConfig,
        initFilters,
        setIsAddPart,
        setEditPart
      } = this.props

      if (setIsAddPart) {
        setIsAddPart(true)
        if (setEditPart) setEditPart('')
      }

      initFilters(filters, addConfig)
      onTogglePopup()
      onUpdateCurConfig(addConfig)
    }
  }

  render() {
    const {
      btnText,
    } = this.props

    return(
      <a
        styleName='addBtn'
        onClick={ this.onAddPart() }
      >
      {btnText}
      </a>
    )
  }
}

AddButton.propTypes = {
  addConfig: PropTypes.object.isRequired,
  btnText: PropTypes.string.isRequired,

  onTogglePopup: PropTypes.func.isRequired,
  onUpdateCurConfig: PropTypes.func.isRequired,
}

export default CSSModules(AddButton, styles)
